import React from 'react';
import styled from 'styled-components';
import { FlexDiv } from '../../../design-system/containers';
import { useTranslation } from 'react-i18next';
import { rgba } from 'polished';
import { palette } from '../../../design-system/colors';
import { TextDefault } from '../../../design-system/texts';

const DecisionChoice = styled(FlexDiv).attrs({
    as: 'button',
    type: 'button',
})`
    border: none;
    font: inherit;
    cursor: pointer;
    width: 100%;
    &:focus {
        outline: none;
    }
    &:focus-visible {
        outline: 2px solid ${palette.evergreen.aspargus};
        outline-offset: 2px;
    }
`;

export default function DecisionOverlayMobile({
    decisionQuestion,
    onAnswer,
    isAtEnd,
}) {
    const { t } = useTranslation();

    const madeDecision = (decision) => {
        onAnswer(decisionQuestion.id, decision);
    };

    return (
        !isAtEnd && (
            <FlexDiv
                backgroundColor={rgba(palette.graphite.heavyMetal, 0.1)}
                fullWidth
                gap={16}
                padding={24}
                column
                mobileOnly
                role="group"
                aria-label={
                    decisionQuestion
                        ? t(decisionQuestion.questionText)
                        : undefined
                }
            >
                <DecisionChoice
                    onClick={() => madeDecision(decisionQuestion.decision_1)}
                    fullWidth
                    justifyCenter
                    alignCenter
                    backgroundColor={palette.graphite.white}
                    borderRadius={4}
                >
                    <TextDefault my={16}>
                        {t(decisionQuestion.decision_1.text)}
                    </TextDefault>
                </DecisionChoice>
                <DecisionChoice
                    onClick={() => madeDecision(decisionQuestion.decision_2)}
                    fullWidth
                    justifyCenter
                    alignCenter
                    backgroundColor={palette.graphite.white}
                    borderRadius={4}
                >
                    <TextDefault my={16}>
                        {t(decisionQuestion.decision_2.text)}
                    </TextDefault>
                </DecisionChoice>
            </FlexDiv>
        )
    );
}
